import { style } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme';
import { mobile } from '@/shared/ui/theme';

export const hologramDivider = style({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  margin: '24px 0',
  '@media': {
    [mobile]: {
      gap: '10px',
      margin: '16px 0',
    },
  },
});

export const dividerLine = style({
  flex: 1,
  height: '1px',
  background: `linear-gradient(90deg, transparent 0%, ${vars.surface.highlight.strong} 30%, ${vars.surface.highlight.strong} 70%, transparent 100%)`,
});

export const dividerDiamond = style({
  width: '8px',
  height: '8px',
  background: vars.bright.primary.default,
  transform: 'rotate(45deg)',
  boxShadow: `0 0 15px ${vars.bright.primary.glow}`,
  '@media': {
    [mobile]: {
      width: '6px',
      height: '6px',
    },
  },
});
